export var CONDITION;
(function (CONDITION) {
    CONDITION["NO"] = "N";
    CONDITION["YES"] = "S";
})(CONDITION || (CONDITION = {}));
//# sourceMappingURL=application-constants.js.map